<template>
  <section class="card--container">
    <b-button variant="link" class="p-0 card--button-pin" v-if="showPin">
      <icons :icon="'PinAngleIcon'" class="mr-05"></icons> 
    </b-button>
    <h1 class="card--name">{{ card.name }}</h1>
    <p class="card--description">{{ card.description }}</p>
    <div class="d-flex justify-content-end">
      <b-button variant="link" class="d-flex align-items-end p-0" @click="openDashboard"><icons :icon="'HandRightIcon'" class="mr-05"></icons>  Acceder</b-button>
    </div>
  </section>
</template>
<script>
import Icons from '@/Icons/Icons.vue'

export default {
  props: {
    card: {
      type: Object,
      default: () => ({})
    }
  },
  components: {Icons},
  data() {
    return {
      showPin: false
    }
  },
  methods: {
    openDashboard() {
      window.open(this.card.url, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
  .card--container {
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 30px;
    flex: 1 1 380px;
    max-width: 445px;
    position: relative;
    .card-name, 
    .card-description {
      margin: 0;
      font-family: Montserrat;
      line-height: 100%;
      letter-spacing: 0;
    }
    .card--name {
      font-weight: 700;
      font-size: 30.4px;
      color: #39549F;
      margin-bottom: 27px;
    }
    .card--description {
      font-weight: 300;
      font-size: 16px;
      padding: 22px;
      border-top: 1px solid #0443890D
    }
    .card--button-pin {
      position: absolute;
      top: 20px;
      right: 20px;
    }
  }
</style>